import { Alert, Box } from "@mui/material";
import useGlobalContext from "../../hooks/useGlobalContext";
import useSWR from "swr";

export default function GeneralNotificationArea() {
  const {
    REQUEST_GENERAL_NOTIFICATION,
    getHeadersWithCorrespondingPagination,
    config,
    basicFilterData,
  } = useGlobalContext();

  const { data } = useSWR([
    REQUEST_GENERAL_NOTIFICATION,
    getHeadersWithCorrespondingPagination(config, 0, basicFilterData),
  ]);

  const showNotificationByType = (notification) => {
    switch (notification.Type) {
      case 0: // Info
        return (
          <Alert key={notification.Id} className="w-full my-2" severity="info">
            <label className="text-xs">{notification.Message}</label>
          </Alert>
        );
      case 1: // Warning
        return (
          <Alert
            key={notification.Id}
            className="w-full my-2"
            severity="warning"
          >
            <label className="text-xs">{notification.Message}</label>
          </Alert>
        );
      case 2: // Error
        return (
          <Alert key={notification.Id} className="w-full my-2" severity="error">
            <label className="text-xs">{notification.Message}</label>
          </Alert>
        );
      case 3: // Success
        return (
          <Alert
            key={notification.Id}
            className="w-full my-2"
            severity="success"
          >
            <label className="text-xs">{notification.Message}</label>
          </Alert>
        );
    }

    return <></>;
  };

  return (
    <Box className="w-full flex flex-col lateral_padding">
      {data?.Data &&
        data.Data.map((notification) => showNotificationByType(notification))}
    </Box>
  );
}
